import { render, staticRenderFns } from "./PostedLifecycle.vue?vue&type=template&id=ab2728d2"
import script from "./PostedLifecycle.vue?vue&type=script&lang=js"
export * from "./PostedLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports